// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Replace the values below with your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDjbtT6T0px31rDURv0gHCvtnXm0U-MElw",
  authDomain: "x8printing-backend.firebaseapp.com",
  projectId: "x8printing-backend",
  storageBucket: "x8printing-backend.firebasestorage.app",
  messagingSenderId: "13769841632",
  appId: "1:13769841632:web:6ba87bec53ff199ffa6985"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore database and Storage
export const db = getFirestore(app);
export const storage = getStorage(app);
